// Generated file - do not change manually!

/**
 * Different types of <code>Breadcrumbs</code> separator.
 */
export enum BreadcrumbsSeparatorStyle {
  /**
   * The separator appears as "\".
   */
  BackSlash = 'BackSlash',

  /**
   * The separator appears as "\\".
   */
  DoubleBackSlash = 'DoubleBackSlash',

  /**
   * The separator appears as ">>".
   */
  DoubleGreaterThan = 'DoubleGreaterThan',

  /**
   * The separator appears as "//".
   */
  DoubleSlash = 'DoubleSlash',

  /**
   * The separator appears as ">".
   */
  GreaterThan = 'GreaterThan',

  /**
   * The separator appears as "/".
   */
  Slash = 'Slash'
}
